import React from 'react'
import "../Styles/Footer.css"

export default function Footer() {
  return (
    <div className="footer"></div>
  )
}
